import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi"; 
import { IoMdClose } from "react-icons/io";        
import "./NavBar.css";
import logo from "../../Asstets/logo.png"; 

const NavBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const isMobile = () => window.innerWidth <= 768;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav 
      className={`navbar ${scrolled ? "navbar-scrolled" : ""}`} 
      role="navigation" 
      aria-label="Main Navigation"
    >
      <div className="navbar-container">

        {/* LOGO */}
        <div className="navbar-logo">
          <Link 
            to="/" 
            onClick={closeMobileMenu}
            title="Skyline Bussiness Solution Home"
          >
            <img 
              src={logo} 
              alt="Skyline Bussiness Solution Logo - Web Development & Digital Marketing Company"
              loading="eager"
            />
          </Link>
        </div>

        {/* MOBILE ICON */}
        <button 
          className="mobile-icon" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle Menu"
        >
          {mobileMenuOpen ? <IoMdClose size={32} /> : <GiHamburgerMenu size={32} />}
        </button>

        {/* NAV LINKS */}
        <ul className={`navbar-links ${mobileMenuOpen ? "active" : ""}`}>

          <li>
            <Link to="/" onClick={closeMobileMenu} title="Home Page">
              Home
            </Link>
          </li>

          <li>
            <Link to="/about" onClick={closeMobileMenu} title="About Us">
              About
            </Link>
          </li>

          {/* DROPDOWN */}
          <li
            className={`dropdown ${dropdownOpen ? "open" : ""}`}
            onMouseEnter={() => !isMobile() && setDropdownOpen(true)}
            onMouseLeave={() => !isMobile() && setDropdownOpen(false)}
          >
            <button
              className="dropdown-label"
              onClick={() => isMobile() && setDropdownOpen(!dropdownOpen)}
              aria-expanded={dropdownOpen}
              aria-haspopup="true"
            >
              Services <small>▼</small>
            </button>

            <ul className="dropdown-menu">

              <li>
                <Link to="/app-software" onClick={closeMobileMenu} title="App Software Development">
                  App Software
                </Link>
              </li>

              <li>
                <Link to="/content-writing" onClick={closeMobileMenu} title="Content Writing Services">
                  Content Writing
                </Link>
              </li>

              <li>
                <Link to="/influencer-marketing" onClick={closeMobileMenu} title="Influencer Marketing Services">
                  Influencer Marketing
                </Link>
              </li>

              <li>
                <Link to="/online-branding" onClick={closeMobileMenu} title="Online Branding Services">
                  Online Branding
                </Link>
              </li>

              <li>
                <Link to="/performance-marketing" onClick={closeMobileMenu} title="Performance Marketing Services">
                  Performance Marketing
                </Link>
              </li>

            </ul>
          </li>

          <li>
            <Link to="/projects" onClick={closeMobileMenu} title="Our Projects">
              Projects
            </Link>
          </li>

          <li>
            <Link to="/blog" onClick={closeMobileMenu} title="Read Our Blog">
              Blog
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={closeMobileMenu} title="Contact Us">
              Contact
            </Link>
          </li>

        </ul>

      </div>
    </nav>
  );
};

export default NavBar;